var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGithub = function SvgGithub(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.94 7.364c-4.968 0-8.993 4.01-8.993 8.959 0 3.963 2.574 7.312 6.15 8.499.45.078.618-.19.618-.426 0-.213-.011-.918-.011-1.668-2.26.414-2.845-.549-3.025-1.053-.1-.258-.54-1.053-.922-1.265-.314-.168-.764-.583-.01-.594.707-.011 1.213.65 1.382.918.81 1.355 2.102.975 2.62.74.078-.583.314-.975.573-1.199-2.001-.224-4.092-.996-4.092-4.423 0-.974.348-1.78.921-2.407-.09-.224-.404-1.143.09-2.374 0 0 .754-.235 2.474.918a8.38 8.38 0 0 1 2.248-.302c.765 0 1.53.1 2.249.302 1.72-1.165 2.473-.918 2.473-.918.495 1.232.18 2.15.09 2.374.574.627.922 1.422.922 2.407 0 3.438-2.102 4.2-4.104 4.423.326.28.608.818.608 1.658 0 1.198-.012 2.16-.012 2.463 0 .235.169.515.619.426 3.552-1.187 6.127-4.547 6.127-8.5 0-4.949-4.025-8.958-8.994-8.958Z",
    fill: "currentColor"
  })));
};
export default SvgGithub;